import axios from 'axios';
import store from "../store";
import authorization from "@/components/webportals/authorization/authorization.js";
export default {
    list,
    service,
    checkGroup
};

async function list(id,taxid) {
    var payload = {
        taxid: taxid,
        group_user:id
    }
    var dataEncode = await authorization.encodeData(payload);
    var auth = await authorization.gentoken(taxid);
    var headers = { Authorization: "Bearer " + auth };
    let result = await axios .post(
          process.env.VUE_APP_R2_API + "config_branchid/select",
          { data: dataEncode },
          { headers }
        )
    if(result.data.status == "OK") {
        store.dispatch("setgroupBranch", result.data.message)
    }
}

async function service(taxid) {
    var payload = {
        taxid: taxid,
        seller_id: localStorage.SELLERID
    }
    var dataEncode = await authorization.encodeData(payload);
    var auth = await authorization.gentoken(taxid);
    var headers = { Authorization: "Bearer " + auth };
    let result = await axios .post(
          process.env.VUE_APP_R2_API + "config_branchid/select/group_branch",
          { data: dataEncode },
          { headers }
        )
    if(result.data.status == "OK") {
        store.dispatch("setGroupServiceh", result.data.message.group_branch)
        if(store.state.groupBranch.length <1 && result.data.message.group_branch) {
            list(store.state.profile.currentuser.id,store.state.profile.id_card_num);
        }
    }
}

async function checkGroup() {
    if(store.getters.groupService == null) {
        service(store.state.profile.id_card_num);
    } else {
        if(store.state.groupBranch.length <1 && store.state.groupService) {
            list(store.state.profile.currentuser.id,store.state.profile.id_card_num);
        }
    }
}


// WEBPACK FOOTER //
// ./src/functions/checkGroupBranch.js